export default __webpack_public_path__ + "static/media/86.ec1124d3.jpg";